// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDSrF8tlUyr587GT7icI4Faj4LbazgxPD8",
  authDomain: "lipijobs-notifications.firebaseapp.com",
  projectId: "lipijobs-notifications",
  storageBucket: "lipijobs-notifications.appspot.com",
  messagingSenderId: "172374588984",
  appId: "1:172374588984:web:294750df983461c9e830cd",
  measurementId: "G-LN2R3NRPNE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
